module.exports = __webpack_public_path__ + "0a4d6041bede1b942e9ceaf793ceeb89.MP3";